/** @format */
import { ProductSearchResultsType } from '../../types';

export const NULL_SEARCH_RESULTS: ProductSearchResultsType = {
    results: [],
    resultCount: 0,
    totalResults: -1,
    spellcheck: {
        suggestions: [],
    },
    sort: {},
};
